import { Box, HStack } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import React from "react";
import CompletedStep from "@components/icons/CompletedStep";
import InProgressStep from "@components/icons/InProgressStep";
import RemainingStep from "@components/icons/RemainingStep";
import { TabItemStatus } from "@models/Order";

interface Props {
	title: string;
	id: string;
	status: TabItemStatus;
	width: string;
	isNextButtonDisabled: boolean;
	activeStepId: number;
	onClick: (id: number) => void;
	isActive?: boolean;
}

const TabItem = ({
	title,
	status,
	width,
	id,
	onClick,
	isActive = false,
	isNextButtonDisabled,
	activeStepId,
}: Props) => {
	let textColor = "";
	let borderColor = "";

	switch (status) {
		case TabItemStatus.Completed:
			textColor = "##333333";
			borderColor = "#9EA0A6";
			break;

		default:
			textColor = "#697386";
			borderColor = "#C1C9D2";
			break;
	}

	if (isActive) {
		textColor = "#333333";
		borderColor = "#4E7EA7";
	}

	const getIcon = () => {
		if (isActive) return <InProgressStep />;
		if (status === TabItemStatus.Completed) return <CompletedStep />;
		return <RemainingStep />;
	};

	return (
		<Box
			mr={2}
			width={width}
			onClick={
				status !== TabItemStatus.Todo && !(isNextButtonDisabled && activeStepId < Number(id))
					? () => onClick(Number(id))
					: undefined
			}
			cursor={
				(status !== TabItemStatus.Todo || isActive) && !(isNextButtonDisabled && activeStepId < Number(id))
					? "pointer"
					: "not-allowed"
			}
		>
			<div
				style={{
					backgroundColor: borderColor,
					height: "4px",
					width: "100%",
					borderRadius: "4px",
				}}
			/>
			<HStack mt={3}>
				{getIcon()}
				<Text color={textColor}>{title}</Text>
			</HStack>
		</Box>
	);
};

export default TabItem;
